import { render, staticRenderFns } from "./addRewardProgram.vue?vue&type=template&id=298463ec&scoped=true&"
import script from "./addRewardProgram.vue?vue&type=script&lang=js&"
export * from "./addRewardProgram.vue?vue&type=script&lang=js&"
import style0 from "./addRewardProgram.vue?vue&type=style&index=0&id=298463ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298463ec",
  null
  
)

component.options.__file = "addRewardProgram.vue"
export default component.exports